import React from 'react'
import { Text, View } from '@react-pdf/renderer'
import getColor from './_getColor'

const RecordSection = ({ title, epcr, ...props }) => {
  const colors = getColor(title)
  return (
    <View
      style={{
        width: '100%',
        flexDirection: 'column',
        borderStyle: 'solid',
        borderColor: colors.bg,
        marginTop: 8,
        marginBottom: 4,
      }}
    >
      <View
        style={{
          width: '100%',
          backgroundColor: colors.bg,
          color: colors.text,
          paddingHorizontal: 2,
          paddingVertical: 4,
          marginBottom: 2,
        }}
        wrap={false}
        minPresenceAhead={40}
      >
        <Text style={{ fontSize: 14, textAlign: 'center' }}>{title}</Text>
      </View>
      <View style={{ width: '100%' }}>{props.children}</View>
    </View>
  )
}

export default RecordSection
